// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import Title from 'components/text/Title';
import constants from '../../../lib/constants/index';

const styles = {
  bottomBar: {
    height: 85,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#2d3142',
  },
};

const getOrganizationEmail = invoice => {
  if (invoice && invoice.organization && invoice.organization.email) {
    return (
      <a href={`mailto:${invoice.organization.email}`} style={{ marginLeft: 4 }}>
        Email {invoice.organization.title}
      </a>
    );
  }

  return null;
};

const getHeyNedEmail = () => {
  return (
    <a style={{ marginRight: 4 }} href={`mailto:${constants.supportEmail}`}>
      Contact HeyNed
    </a>
  );
};

const BottomBar = ({ invoice }) => {
  return (
    <div style={styles.bottomBar}>
      <div style={{ textAlign: 'center' }}>
        <Title style={{ color: '#fff' }}>Have Questions?</Title>
        <span style={{ fontSize: 15, color: '#fff', margin: 0 }}>
          {getHeyNedEmail()} or {getOrganizationEmail(invoice)}
        </span>
      </div>
    </div>
  );
};

export default BottomBar;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/BottomBar/index.js